import type { ServicesResourcesTranslationMessages } from './servicesResourcesTranslationMessages';

export const servicesResourcesLanguageEnglish: ServicesResourcesTranslationMessages = {
  soundfiles: {
    name: 'Soundfiles',
    description: 'List and manage all your soundfiles',
    fields: {
      id: 'ID',
      description: 'Description',
      fileUploadHint: `Drop a soundfile or click to select it.\nAccepted files: .mp3, .wav`,
      name: 'Name',
      labels: { id: 'Labels', name: 'Labels' },
    },
    errors: {
      fileInvalid: 'File format is not valid',
      fileTooBig: 'File size is too big',
      fileNotFound: 'Sound file not found, please retry',
      generic: 'Upload error, please retry',
    },
    operations: {
      create: 'Add soundfile',
      delete: 'Delete the soundfile',
      edit: 'Edit soundfile',
      sections: {
        details: 'Soundfile info',
      },
    },
    serviceButtonLabel: 'Manage',
  },
};
